var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "dont-leave-modal",
      attrs: {
        name: "dont-leave-modal",
        width: "500",
        height: "auto",
        adaptive: true
      },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c("div", { staticClass: "modal-box" }, [
        _c(
          "div",
          {
            staticClass: "close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          },
          [
            _c("img", {
              attrs: {
                src:
                  "https://enklav-production.s3.amazonaws.com/uploads/image/x-20x20-white.svg"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "m-header bold" }, [
          _c("p", [_vm._v("Hang tight!")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "m-body" }, [
          _vm.is_video_uploaded
            ? _c("p", [
                _vm._v("Please Save the card before leaving to keep your work.")
              ])
            : _c("div", [
                _c("p", [
                  _vm._v(
                    "Your video is uploading now, so please don’t leave yet."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Once it’s processing, you’re welcome to hit “Save” and move on—just be sure to choose a thumbnail cover image" +
                      _vm._s(_vm.for_product ? " or add a trailer" : "") +
                      "."
                  )
                ])
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "actions" }, [
            _c(
              "div",
              {
                staticClass: "_btn round-btn purple",
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_vm._v("Back to page")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "_btn round-btn",
                on: {
                  click: function($event) {
                    return _vm.confirm_fn()
                  }
                }
              },
              [_vm._v("Leave")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }